import React from 'react';

import EditIcon from '@usas/ui-web/components/icons/EditIcon';

import global from '@usas/ui-web/components/GlobalStyle.module.css';

const GridRow = ({ groupInvite, onGroupInviteClicked }) => (
  <div className={global.SmallTableRow}>
    <div className={global.SmallTableRowHead}>
      <span className='hidden-xs'>{groupInvite.firstName || ''} {groupInvite.lastName || ''}</span>&nbsp;
      <button
        className={global.IconButton}
        type="button"
        onClick={(e) => onGroupInviteClicked(e, groupInvite)}>
        <EditIcon />
      </button>
    </div>
    <div className={global.SmallTableRowInfo}>
      <div className='row'>
        <div className={[global.SmallTableRowLabels, 'col-xs-6 visible-xs'].join(' ')}>Name</div>
        <div className={[global.SmallTableRowData, 'col-xs-6 visible-xs'].join(' ')}>{groupInvite.firstName || ''} {groupInvite.lastName || ''}</div>
        <div className={[global.SmallTableRowLabels, 'col-xs-6 col-sm-3'].join(' ')}>Group</div>
        <div className={[global.SmallTableRowData, 'col-xs-6 col-sm-3'].join(' ')}>{groupInvite.groupName || ''}</div>
      </div>
    </div>
  </div>
);

const SmallGrid = ({ data, isLoading, onGroupInviteClicked }) => (
  <div className={[global.SmallTable, 'hidden-lg hidden-md'].join(' ')}>
    {isLoading === true
      ? (
        <div className={global.SmallTableRow}>
          <div className={global.SmallTableRowHead}>&nbsp;</div>
          <div className={global.SmallTableRowInfo}>
            <div className={global.SmallTableRowLabels}>Loading...</div>
          </div>
        </div>
      )
      : data.length > 0
        ? data.map((groupInvite, i) => <GridRow key={i} groupInvite={groupInvite} onGroupInviteClicked={onGroupInviteClicked} />)
        : (
          <div className={global.SmallTableRow}>
            <div className={global.SmallTableRowHead}>&nbsp;</div>
            <div className={global.SmallTableRowInfo}>
              <div className={global.SmallTableRowLabels}>No Group Invites</div>
            </div>
          </div>
        )
    }
  </div>
);

export default SmallGrid;